/*
  Makes clicking a product-media thumbnail actually navigate the main
  image slider to that photo. This is a general fix, independent of the
  color-gallery filter, and applies to every product with a thumbnail
  gallery.

  Root cause #1: the theme's thumbnail Swiper instance is configured with
  slideToClickedSlide:false, so Swiper itself never wires up click ->
  navigate. The only thing that used to move the main slider on a
  thumbnail click was the "thumbnail changes variant" mechanism, and
  that only worked for the one thumbnail per color that happens to match
  a variant's featured image - every other thumbnail click did nothing.

  Root cause #2: the main slider uses Swiper's fade effect with loop:true.
  Swiper's loop mode maintains extra clone slides in the DOM to allow
  wrap-around. When slides are added/removed from the DOM (e.g. by the
  color-gallery-filter script), those clones become stale/mismatched,
  which leaves the fade effect showing a blank (opacity:0) slide after
  navigating with slideTo(). Rebuilding the loop (loopDestroy + loopCreate)
  right before navigating keeps the clones in sync with the current real
  slides so the fade effect computes the correct opacity.

  This file wires up a plain, reliable click -> slideTo for every
  thumbnail, matching thumbnail to main slide by their shared media id.
*/
(function () {
  function getMainSlides(mainEl) {
    var wrapper = mainEl.querySelector('.swiper-wrapper');
    return wrapper ? Array.prototype.slice.call(wrapper.children) : [];
  }

  function getThumbSlides(thumbsEl) {
    var wrapper = thumbsEl.querySelector('.swiper-wrapper');
    return wrapper ? Array.prototype.slice.call(wrapper.children) : [];
  }

  function findMediaId(thumbSlide) {
    if (thumbSlide.hasAttribute('data-media-id')) return thumbSlide.getAttribute('data-media-id');
    var idEl = thumbSlide.querySelector('[data-image-id]');
    return idEl ? idEl.getAttribute('data-image-id') : null;
  }

  function navigateMainTo(mainEl, targetIndex) {
    var swiper = mainEl.swiper;
    if (!swiper) return;
    try {
      if (swiper.params && swiper.params.loop && typeof swiper.loopDestroy === 'function' && typeof swiper.loopCreate === 'function') {
        swiper.loopDestroy();
        swiper.loopCreate();
      }
      swiper.update();
    } catch (e) {}
    swiper.slideTo(targetIndex);
  }

  function bindThumb(thumbSlide, mainEl) {
    if (thumbSlide.__thumbClickFixBound) return;
    thumbSlide.__thumbClickFixBound = true;
    thumbSlide.addEventListener('click', function () {
      var mediaId = findMediaId(thumbSlide);
      if (!mediaId) return;
      var mainSlides = getMainSlides(mainEl);
      var targetIndex = -1;
      for (var i = 0; i < mainSlides.length; i++) {
        if (mainSlides[i].getAttribute('data-media-id') === mediaId) {
          targetIndex = i;
          break;
        }
      }
      if (targetIndex === -1) return;
      navigateMainTo(mainEl, targetIndex);
    });
  }

  function wire(productMediaEl) {
    var mainEl = productMediaEl.querySelector('[data-slider-main]');
    var thumbsEl = productMediaEl.querySelector('[data-media-thumbnails]');
    if (!mainEl || !thumbsEl) return;

    function bindAll() {
      getThumbSlides(thumbsEl).forEach(function (slide) {
        bindThumb(slide, mainEl);
      });
    }

    bindAll();

    var wrapper = thumbsEl.querySelector('.swiper-wrapper');
    if (wrapper && window.MutationObserver) {
      var observer = new MutationObserver(bindAll);
      observer.observe(wrapper, { childList: true });
    }
  }

  function init() {
    document.querySelectorAll('product-media').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
